import * as angular from "angular";
import {
  AiAgentModel,
  AiAgentTriggerType,
  AiAgentType,
  AiModel,
  AiRecommendationTriggerPrompt,
  AiUserVariableType
} from "../models/ai-agent.model";

export class AiAgentsDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {}

  createAiAgent(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/ai-agent-form-dialog.html').default,
      controller: function ($scope) {

        const aiAgent: AiAgentModel = {
          name: undefined,
          description: undefined,
          type: AiAgentType.Recommendation,
          active: true,
          systemPrompt: {
            instruction: undefined
          },
          aiChatOptions:{
            aiModel: AiModel.GeminiFlashLite_2_5
          },
          triggerPrompts:[]
        }

        $scope.aiAgent = aiAgent;

        $scope.header = 'Create AI Agent';
        $scope.models = Object.values(AiModel);
        $scope.types = Object.values(AiAgentType);
        $scope.triggers = Object.values(AiAgentTriggerType);
        $scope.variables = Object.values(AiUserVariableType);

        $scope.onAddUserPrompt = () => {
          const triggerPrompt: AiRecommendationTriggerPrompt = {
            triggerType: AiAgentTriggerType.VpAccountCreated,
            enabled: true,
            userPrompt: {
              instruction: undefined,
              variables: []
            }
          }
          $scope.aiAgent.triggerPrompts.push(triggerPrompt);
        }

        $scope.onRemoveTrigger = (index) => {
          $scope.aiAgent.triggerPrompts.splice(index, 1);
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.aiAgent);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  editAiAgent(aiAgent: AiAgentModel, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/ai-agent-form-dialog.html').default,
      controller: function ($scope) {

        $scope.aiAgent = aiAgent;
        $scope.header = 'Edit AI Agent';
        $scope.models = Object.values(AiModel);
        $scope.types = Object.values(AiAgentType);
        $scope.triggers = Object.values(AiAgentTriggerType);
        $scope.variables = Object.values(AiUserVariableType);
        $scope.isEdit = true;

        $scope.onAddUserPrompt = () => {
          const triggerPrompt: AiRecommendationTriggerPrompt = {
            triggerType: AiAgentTriggerType.VpAccountCreated,
            enabled: true,
            userPrompt: {
              instruction: undefined,
              variables: []
            }
          }
          $scope.aiAgent.triggerPrompts.push(triggerPrompt);
        }

        $scope.onRemoveTrigger = (index) => {
          $scope.aiAgent.triggerPrompts.splice(index, 1);
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.aiAgent);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }
}

angular
  .module('bringoz.admin.ai-agents')
  .service('aiAgentsDialogService', AiAgentsDialogService);
